export const updateSetupData = /* GraphQL */ `
  mutation UpdateSetupData(
    $input: UpdateSetupDataInput!
    $condition: ModelSetupDataConditionInput
  ) {
    updateSetupData(input: $input, condition: $condition) {
      id
      groups
      status
      cognitoId
    }
  }
`;

export const updateLocationMini = /* GraphQL */ `
  mutation UpdateLocation(
    $input: UpdateLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    updateLocation(input: $input, condition: $condition) {
      id
      updatedAt
    }
  }
`;

export const updateCustomerMini = /* GraphQL */ `
  mutation UpdateCustomer(
    $input: UpdateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    updateCustomer(input: $input, condition: $condition) {
      id
      updatedAt
    }
  }
`;

export const updateUserMini = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
    }
  }
`;

export const updateReloadYard = /* GraphQL */ `
  mutation UpdateReloadYard(
    $input: UpdateReloadYardInput!
    $condition: ModelReloadYardConditionInput
  ) {
    updateReloadYard(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      name
      phone
      fax
      email
      website
      street
      city
      state
      zipCode
      country
      timeZone
      latitude
      longitude
      geofence
      geofenceToleranceMeters
      geofenceEnabled
      geofenceEnforced
      driverCheckInEnabled
      driverIdentificationRequired
      driverIdScanRequired
      driverCheckInGraceMinutes
      driverCheckInWithoutAppointment
      driverInstructions
      postCheckInMessage
      driverStops {
        label
        message
      }
      lotCapacity
      trackCapacity
      warehouseCapacity
      servingCarrier
      railHighway
      ast
      externalCompanyId
      taxRates {
        taxCode
        taxRate
      }
      paymentTerms {
        items {
          id
          name
          code
          type
          dueDays
          # dayOfMonthDue
          sortKey
        }
      }
      invoiceNumberPrefix
      invoiceCounter
      bolTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      fileCategories {
        key
        name
      }
      mapImage {
        bucket
        region
        key
      }
      logoImage {
        bucket
        region
        key
      }
      areas {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          zones {
            items {
              id
              owner
              groups
              active
              reloadYardId
              name
              prefix
              color
              zoneType
              sortKey
            }
            nextToken
          }
        }
        nextToken
      }
      zones {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          zoneType
          sortKey
        }
        nextToken
      }
      aisles {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          areaId
          zoneId
          capacityUsed
          type
          bays
          levels
          length
          width
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      yardCommodities {
        items {
          id
          active
          reloadYardId
          commodityId
          units
          sortKey
          commodity {
            id
            name
          }
        }
        nextToken
      }
      subscription {
        customerId
        subscriptionId
        priceId
        status
      }
      # tosAccept {
      #   acceptTimeStamp
      #   cognitoId
      #   email
      #   userAgent
      #   ip
      # }
      # attachments {
      #   bucket
      #   region
      #   key
      #   type
      #   createdBy
      #   createdAt
      # }
      schedule {
        workdays {
          id
          name
          startDayTime
          endDayTime
          selected
        }
        holidays
        minNoticeHours
        maxDaysIntoFuture
        layout
      }
      eventTypes {
        items {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          schedule {
            workdays {
              id
              name
              startDayTime
              endDayTime
              selected
            }
            holidays
            minNoticeHours
            maxDaysIntoFuture
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      railEquipmentTypes {
        items {
          id
          name
          arrTypeCode
          length
          sortKey
        }
      }
      truckEquipmentTypes {
        items {
          id
          name
          dotSpecCode
          dotClassCode
          length
          sortKey
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const updateReloadYardMini = /* GraphQL */ `
  mutation UpdateReloadYard(
    $input: UpdateReloadYardInput!
    $condition: ModelReloadYardConditionInput
  ) {
    updateReloadYard(input: $input, condition: $condition) {
      id
      updatedAt
    }
  }
`;

export const createCustomerReloadYardAccountMini = /* GraphQL */ `
  mutation CreateCustomerReloadYardAccount(
    $input: CreateCustomerReloadYardAccountInput!
    $condition: ModelCustomerReloadYardAccountConditionInput
  ) {
    createCustomerReloadYardAccount(input: $input, condition: $condition) {
      id
      updatedAt
    }
  }
`;

export const updateCustomerReloadYardAccountMini = /* GraphQL */ `
  mutation UpdateCustomerReloadYardAccount(
    $input: UpdateCustomerReloadYardAccountInput!
    $condition: ModelCustomerReloadYardAccountConditionInput
  ) {
    updateCustomerReloadYardAccount(input: $input, condition: $condition) {
      id
      updatedAt
    }
  }
`;
